import React, { Component } from 'react';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { StyleSheet, css } from 'aphrodite';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';

export class MessageActionDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      success: true,
      hideActionBtn: true,
      inProcess: true,
      errMsg: null
    };
  }

  componentDidMount() {
    this.doAction()
  }

  onCloseModal() {
    this.props.onClosed()
  }

  doAction() {
    this.setState({
      inProcess: true,
      errMsg: null
    })
    const payload = {
      method: this.props.apiMethod,
      endPoint: this.props.apiEndPoint,
    }

    ApiHelper.call(
      payload,
      function (err, data) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err),
            success: false,
            inProcess: false
          })
          return;
        }

        this.setState({
          success: true,
          hideActionBtn: false,
          inProcess: false,
          errMsg: null
        })
        if(this.props.onFetchSuccess) {
          this.props.onFetchSuccess(data)
        }
      }.bind(this));
  }

  generateActions() {

    const dialogAction = <div className={css(Styles.actions)}>
      {this.state.errMsg &&
        <span className={css(Styles.errorMsg)}>
          {this.state.errMsg}
        </span>
      }
      {this.state.inProcess && <CircularProgress size={24} className={css(Styles.marginLeft)} />}
      {!this.state.hideActionBtn &&
        <Button
          className={css(Styles.button)}
          variant='contained'
          color='primary'
          disabled={this.state.inProcess}
          onClick={() => this.props.buttonAction()}
        >
          {this.props.buttonText}
        </Button>
      }
    </div>

    return dialogAction
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth}
        classes={{
          root: css(Styles.customRoot),
          paper: css(Styles.customPaper),
        }}
        maxWidth='md'
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
              <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
            </svg>
          </button>
        </div>
        <div className={this.props.modalContent ? css(this.props.modalContent) : css(Styles.modalContent)}>
          {this.props.message}
          {this.props.renderContent &&
            this.props.renderContent()
          }
          {this.props.buttonText &&
            this.generateActions()
          }
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  modalHeader: {
    backgroundColor: 'whitesmoke',
    padding: 10,
  },
  modalTitle: {
    color: 'black',
    fontSize: 20,
  },
  modalContent: {
    maxWidth: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 20,
    padding: 10,
    minHeight: 130
  },
  modalCloseButton: {
    position: 'absolute',
    top: 8,
    right: 5,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 28,
    height: 28
  },
  errorMsg: {
    textAlign: 'center',
    color: 'red',
    marginBottom: 10
  },
  successMsg: {
    textAlign: 'center',
    paddingRight: 20,
    color: 'green',
    marginBottom: 10
  },
  marginLeft: {
    //marginLeft: 10
  },
  button: {
    color: AppTheme.buttonTextColor,
    boxShadow: 'none',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20
  },
  customRoot: {
  },
  customPaper: {
    boxShadow: 'none',
    minWidth: 400
  }
})



// WEBPACK FOOTER //
// ./src/components/MessageActionDialog.js